import { render } from "./CustomerCampaign.vue?vue&type=template&id=9d2a0bee&scoped=true&lang=pug"
import script from "./CustomerCampaign.vue?vue&type=script&lang=js"
export * from "./CustomerCampaign.vue?vue&type=script&lang=js"

import "./CustomerCampaign.vue?vue&type=style&index=0&id=9d2a0bee&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9d2a0bee"]])

export default __exports__